import styled from 'styled-components';

const Strong = styled.strong`
  color: ${({ theme }) => theme.themeColor.primaryColor};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export default Strong;
